import { useEffect } from 'react';
import InnerPageHero from '../components/InnerPageHero';
import ServiceAreasExpanded from '../components/ServiceAreasExpanded';
import FAQ from '../components/FAQ';
import { useContent } from '../context/ContentContext';

export default function ServiceAreasPage() {
  const { content } = useContent();
  const h = content.serviceLocationHero;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" tabIndex={-1}>
      <InnerPageHero
        breadcrumbs={[
          { label: 'Home', href: '/' },
          { label: 'Service Areas' },
        ]}
        title={h.title}
        titleAccent={h.titleAccent}
        titleSuffix={h.titleSuffix}
        description={h.description}
      />
      <ServiceAreasExpanded />
      <FAQ />
    </main>
  );
}
